module.exports = __webpack_public_path__ + "img/hiking-ul.33a23eb5.webp";